export default __webpack_public_path__ + "static/media/icon-close-modal.9bee7e53.svg";